import _createIconComponent from './utils/createIconComponent';
const _createIconComponent2 = _interopRequireDefault(_createIconComponent);
import _react from 'react';
const _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
const IconCorrectSolid = (0, _createIconComponent2.default)({
    content: _react2.default.createElement(
        "g",
        null,
        _react2.default.createElement("path", {
            d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM15.091 6.03492L14.3874 5.45925L8.69526 12.4163L5.4744 9.71981L4.89082 10.4169L8.81665 13.7036L15.091 6.03492Z",
            fillRule: "evenodd",
            clipRule: "evenodd",
        })
    ),
    height: 22,
    width: 22,
});
IconCorrectSolid.displayName = "IconCorrectSolid";
export default IconCorrectSolid;
